import { ApiError } from 'types';

// replace with isMpApiError
export function isApiError(error: any): error is ApiError {
  return error?.name === 'ApiError'
}

export type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T;
};
